import { useEffect, useState } from "react";
import { Loader2, Activity } from "lucide-react";
import StatCard from "../../components/cockpit/StatCard";
import { fetchCockpitActivity, type CockpitActivity } from "../../lib/admin";
import { formatMontant } from "@/lib/formatMontant";

function fmt(n: number): string {
  return formatMontant(n);
}

export default function CockpitActivite() {
  const [act, setAct] = useState<CockpitActivity | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    fetchCockpitActivity(7)
      .then((a) => {
        if (alive) setAct(a);
      })
      .catch(() => {
        if (alive) setErr("Impossible de charger l’activité.");
      });
    return () => {
      alive = false;
    };
  }, []);

  if (err) {
    return <p className="text-sm text-red-400">{err}</p>;
  }
  if (!act) {
    return (
      <div className="flex justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-orange-500" />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-4xl space-y-8">
      <div className="flex items-center gap-3">
        <Activity className="h-8 w-8 text-orange-500" />
        <div>
          <h2 className="text-xl font-bold text-slate-900">Activité récente</h2>
          <p className="text-sm text-slate-400">
            Agrégats sur les {act.periode_jours} derniers jours (écritures & factures créées).
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-[#e4e8ef] bg-[#e4e8ef] sm:grid-cols-3">
        <StatCard inGrid accent title="Nouvelles écritures" value={fmt(act.nouvelles_ecritures)} />
        <StatCard inGrid title="Nouvelles factures vente" value={fmt(act.nouvelles_factures_vente)} />
        <StatCard inGrid title="Nouvelles factures achat" value={fmt(act.nouvelles_factures_achat)} />
      </div>
    </div>
  );
}
